import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import {
  BaseControl,
  Textbox,
  Custom,
  AsociacionTareaForma
} from '@app/shared';


@Injectable()
export class AssociationTaskFormsService {
  constructor() { }

  /**
   * Genera el formulario de agregar o modificar la asociacion
   *
   * @param {*} template
   * @param {*} options
   * @param {AsociacionTareaForma} [association]
   * @returns {BaseControl<any>[]}
   * @memberof AssociationTaskFormsService
   */
  getFormAssociations(template: any, options: any, association?: AsociacionTareaForma): BaseControl<any>[] {
    const controls: BaseControl<any>[] = [
      new Textbox({
        key: 'txtAliasTask',
        label: 'Alias de la asociacion:',
        value: association ? association.aliasAsociacion : '',
        order: 1,
        placeholder: 'Ingresar el alias de la asociacion que contiene la forma',
        describe: 'Este alias debe ser el mismo alias ingresado para la asociacion de la tarea.',
        validations: {
          validators: [Validators.required]
        }
      }),
      new Custom({
        key: 'cboForm',
        label: 'Forma asociada:',
        value: association ? association.nombreForma : null,
        template: template,
        options: options['formsList'] ? options['formsList'] : [],
        order: 2,
        placeholder: 'Seleccionar la forma conteniada por la asociacion',
        validations: {
          validators: [Validators.required]
        }
      }),
      new Custom({
        key: 'cboVersion',
        label: 'Version:',
        template: template,
        options: options.formVersion ? options.formVersion : [],
        value: association ? association.idForma : null,
        order: 3,
        placeholder: 'Seleccionar la version de la forma asociada',
        validations: {
          validators: [Validators.required]
        }
      }),
    ];

    return controls.sort((a, b) => a.order - b.order);
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/creation-dynamic-component/association-task-forms/shared/association-task-forms-component.forms.service.ts